import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "line-clamp-1" }
const _hoisted_2 = { class: "flex flex-none justify-end" }

import { ref } from "vue";
import { useManagedPatientsStore } from "@/store/managedPatientsStore";

import { supabase } from "@/helpers/supabase";
import {
  ManagedPatient,
  ManagedPatientDataPoint,
} from "@/interfaces/managedPatient";
import { hexToBytes, decryptSymmetricBytes } from "@/helpers/encryption";

import CoreIcon from "@/components/CoreIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatientFile',
  props: {
    file: {},
    small: { type: Boolean },
    allowDelete: { type: Boolean },
    patient: {}
  },
  setup(__props: any) {

const managedPatientsStore = useManagedPatientsStore();

const props = __props;

const loading = ref<boolean>(false);

async function download(file: ManagedPatientDataPoint, openInNewTab: boolean) {
  loading.value = true;
  let download = await supabase.storage
    .from("patient_files")
    .download(`${file.file_path}`);
  let buffer = await download.data?.arrayBuffer();
  let key = managedPatientsStore.keys?.get(file.used_key_id);
  if (!buffer || !key?.decrypted_symmetric_key) return;
  const decryptFileObj = await decryptSymmetricBytes(
    new Uint8Array(buffer),
    hexToBytes(file.nonce),
    key.decrypted_symmetric_key
  );
  const fileName: string = file.decrypted_data.fileName;
  const ending = fileName.split(".").at(-1)?.toLowerCase();
  // downloadFile(decryptFileObj, fileName);
  let contentType = "application/octet-stream";
  if (ending == "png" || ending == "jpg" || ending == "gif") {
    contentType = "image/" + ending;
  }
  if (ending == "pdf") {
    contentType = "application/pdf";
  }
  openInNewTab
    ? showFileInIframe(decryptFileObj, contentType)
    : await downloadFile(decryptFileObj, fileName);
}

// Function to trigger the download
async function downloadFile(data: Uint8Array, filename: string) {
  const blob = new Blob([data], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();

  // Cleanup
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
  window._paq.push(["trackEvent", "PatientFile", "download", undefined]);
}

function showFileInIframe(data: Uint8Array, contentType: string) {
  const blob = new Blob([data], { type: contentType });
  const url = URL.createObjectURL(blob);
  const objectTag = document.createElement("object");
  objectTag.data = url;
  objectTag.type = contentType;

  objectTag.style.minWidth = "300px";

  objectTag.style.position = "absolute";
  objectTag.style.top = "10%";
  objectTag.style.left = "calc(50% - 150px)";
  document.body.appendChild(objectTag);
  loading.value = false;

  // Cleanup
  //URL.revokeObjectURL(url);
}

async function deleteFile(file: ManagedPatientDataPoint | null) {
  if (file == null) return;

  await supabase.from("managedPatient_deletedFiles").insert({
    managed_patient_id: props.patient.id,
    data_id: file.id,
  });
  if (file.file_path) {
    await supabase.storage.from("patient_files").remove([file.file_path]);
  }

  window._paq.push(["trackEvent", "PatientFile", "delete", undefined]);
}

return (_ctx: any,_cache: any) => {
  return (_ctx.file)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex items-center", { 'justify-between': !_ctx.small, 'justify-start': _ctx.small }])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.file.decrypted_data.fileName), 1),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.allowDelete)
            ? (_openBlock(), _createBlock(CoreIcon, {
                key: 0,
                icon: "trash",
                small: _ctx.small,
                class: _normalizeClass(["flex-none", { 'ml-xs': _ctx.small }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteFile(_ctx.file)))
              }, null, 8, ["small", "class"]))
            : _createCommentVNode("", true),
          _createVNode(CoreIcon, {
            icon: "download",
            small: _ctx.small,
            class: _normalizeClass(["flex-none", { 'ml-xs': _ctx.small }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (download(_ctx.file, false)))
          }, null, 8, ["small", "class"])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})